<!-- Design: Trovve.dc.html 517-582. No backdrop and no click-away layer on purpose — the card is
     non-modal, so everything behind it keeps working while it is up. -->
<div class="vf-tdn" *ngIf="visible" role="status" aria-live="polite"
    [class.vf-tdn--out]="leaving"
    (mouseenter)="onInteract()" (focusin)="onInteract()" (click)="onInteract()">

    <!-- ── ASK ── keyed off `content`, never off the leave flag: whichever face is up has to stay up
         while the card animates out, or dismissing the green check flashes this back on the way. -->
    <ng-container *ngIf="content === 'ask'">
        <div class="vf-tdn__head">
            <span class="vf-tdn__cal" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                <span class="vf-tdn__badge">?</span>
            </span>

            <div class="vf-tdn__text">
                <div class="vf-tdn__title">{{ title }}</div>
                <div class="vf-tdn__sub">{{ subLine }}</div>
            </div>

            <button type="button" class="vf-tdn__x" (click)="dismiss()" aria-label="Not now">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
            </button>
        </div>

        <div class="vf-tdn__opts">
            <button type="button" class="vf-tdn__opt" *ngFor="let o of options; trackBy: trackByOption"
                [class.vf-tdn__opt--on]="pendingKey === o.key" [disabled]="saving" (click)="pickOption(o)">
                <span>{{ o.label }}</span><span class="vf-tdn__opt-hint">{{ o.weekday }}</span>
            </button>

            <button type="button" class="vf-tdn__opt vf-tdn__opt--custom"
                [class.vf-tdn__opt--on]="calendarOpen" [disabled]="saving"
                [attr.aria-expanded]="calendarOpen" (click)="toggleCalendar()">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>Pick a date
            </button>
        </div>

        <!-- The app's own calendar, inline: today green, past greyed and unselectable. Same component
             the Snooze menus use, so there is one date picker in the product. -->
        <div class="vf-tdn__cal-wrap" *ngIf="calendarOpen">
            <vf-date-picker
                [variant]="'inline'"
                [fluid]="true"
                [todayDate]="today"
                [minDate]="today"
                [footerAction]="'cancel'"
                (dateChange)="pickCalendarDate($event)"
                (cancelled)="closeCalendar()"></vf-date-picker>
        </div>

        <p class="vf-tdn__error" *ngIf="errorMessage">{{ errorMessage }}</p>

        <div class="vf-tdn__foot">
            <button type="button" class="vf-tdn__leave" [disabled]="saving" (click)="dismiss()">Leave it undated</button>
            <span class="vf-tdn__streak">{{ streakLabel }}</span>
        </div>

        <!-- Auto-dismiss countdown. Amber, thin, and purely informational — nothing is required of the user. -->
        <div class="vf-tdn__bar" aria-hidden="true">
            <div class="vf-tdn__bar-fill vf-tdn__bar-fill--run" #timerBar [class.vf-tdn__bar-fill--held]="calendarOpen || saving"></div>
        </div>
    </ng-container>

    <!-- ── DONE ── -->
    <div class="vf-tdn__done" *ngIf="content === 'done'">
        <span class="vf-tdn__check" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        </span>
        <div class="vf-tdn__text">
            <div class="vf-tdn__done-title">{{ doneTitle }}</div>
            <div class="vf-tdn__done-sub">{{ doneSubLine }}</div>
        </div>
    </div>
</div>
